import { Eyebrow } from './Eyebrow.jsx';
import { Wrap } from './Section.jsx';
import styles from './PageHero.module.css';

/**
 * The masthead on every interior page. `lines` splits the heading so it
 * breaks where the design wants it to rather than wherever the column
 * happens to run out.
 */
export function PageHero({ eyebrow, lines, lede }) {
  return (
    <section className={styles.pageHero}>
      <Wrap>
        <Eyebrow animated={false}>{eyebrow}</Eyebrow>
        <h1 className="h1">
          {lines.map((line, i) => (
            <span key={line}>
              {i > 0 ? <br /> : null}
              {line}
            </span>
          ))}
        </h1>
        <p className="lede">{lede}</p>
      </Wrap>
    </section>
  );
}
